import React from 'react'

import { Button, useModalContext } from '@sketch/components'
import { UnpublishProfileModal } from '../../modals'

export interface HideProfileSectionProps {
  identifier: string
}
export const HideProfileButton = (props: HideProfileSectionProps) => {
  const { identifier } = props
  const { showModal } = useModalContext()

  return (
    <Button
      size="40"
      variant="secondary"
      onClick={() => showModal(UnpublishProfileModal, { identifier })}
    >
      Hide Profile
    </Button>
  )
}
